import React, {useEffect} from 'react';
import About_discraption from '../Component/About_discraption'
import Company_staff from '../Component/Company_staff'
import About_poster from '../Component/About_poster'
import About_total_count from '../Component/About_total_count'
import Strengths_comp from '../Component/Strengths_comp'
import Our_vision from '../Component/Our_vision'


function About_us() {
  useEffect(()=>{
    document.title='About Us | InternsElite';
  },[]);
  return (
    <>
    <div className='About_postion'><About_poster/></div>
    <div><About_discraption/></div>
    <div><Our_vision/></div>
    <div><Strengths_comp/></div>
    <div><Company_staff/></div>
    <div><About_total_count/></div>
    </>
  )
}

export default About_us
